import React, { useState } from 'react';
import { Stack, Card, DataTable, SkeletonBodyText, Text } from '@shopify/polaris';

import HistoryFilter from '../../../components/HistoryFilter';
import HistoryTablePagination from '../../../components/HistoryTablePagination';
import { DateRange } from '../../Dashboard/useDateRange';
import useShopStandaloneCarts from '../../../hooks/useShopStandaloneCarts';
import { useAppAuthState } from '../../../authState';
import standaloneCartDataTableRow from '../../../utils/standaloneCarts';
import useShopUsers from '../../../hooks/useShopUsers';
import useExportStandaloneCarts from '../../../hooks/useExportStandaloneCarts';

const defaultFilter = {
      hostId: null,
      range: DateRange.last30,
};

const ROWS_PER_PAGE = 15;
const CONTENT_TYPES = ['text', 'text', 'text', 'text', 'text'];
const HEADERS = () => [
      'Cart Date',
      'Client Data',
      'Host Name',
      'Order Date',
      'Sales Amount',
];

export default function StandaloneCartHistoryTable() {
      const { shopOrigin } = useAppAuthState();
      const { hosts } = useShopUsers(shopOrigin);
      const [filter, setFilter] = useState(defaultFilter);
      const [currentPage, setCurrentPage] = useState(0);

      const {
            standaloneCarts,
            loading,
            refresh: refreshStandaloneCarts,
            getMoreCarts,
            getHistoryCarts
      } = useShopStandaloneCarts(shopOrigin, ROWS_PER_PAGE, filter);

      const { exportHistoryStandaloneCarts, isExportInProgress } = useExportStandaloneCarts(getHistoryCarts, shopOrigin, filter, hosts);

      const mapCartToTable = (doc) => {
            const standaloneCartData = doc.data();
            const { createdByUser } = standaloneCartData;
            const neededHost = hosts.find(host => host.id === createdByUser);
            const { row } = standaloneCartDataTableRow({ standaloneCartData, neededHost });

            return row;
      };

      const handlerOnChangePage = (page) => {
            if ((page + 1) * ROWS_PER_PAGE >= standaloneCarts.length) {
                  getMoreCarts();
            }
            setCurrentPage(page);
      }

      const refreshTable = () => {
            refreshStandaloneCarts();
            setCurrentPage(0);
      };

      const currentCarts = standaloneCarts.slice(currentPage * ROWS_PER_PAGE, (currentPage + 1) * ROWS_PER_PAGE).map(mapCartToTable);
      const hasNext = (standaloneCarts.length > (currentPage + 1) * ROWS_PER_PAGE);

      const footerContent = () => {
            if (standaloneCarts.length > 0) {
                  return (
                        <HistoryTablePagination
                              currentPage={currentPage}
                              hasNext={hasNext}
                              itemsPerPage={ROWS_PER_PAGE}
                              onChangePage={handlerOnChangePage}
                              noun="carts"
                        />
                  )
            }

            return (
                  loading ? (
                        <SkeletonBodyText lines={4} />
                  ) : (
                        <Text>{'No carts found'}</Text>
                  )
            )
      };

      return (
            <Stack vertical>
                  <HistoryFilter
                        onChangeFilter={setFilter}
                        onRefresh={refreshTable}
                        onExport={currentCarts?.length ? exportHistoryStandaloneCarts : null}
                        isExportInProgress={isExportInProgress}
                        defaultFilter={defaultFilter}
                        hideSearch
                        hideEventTypes
                  />

                  <Card>
                        <DataTable
                              columnContentTypes={CONTENT_TYPES}
                              headings={HEADERS()}
                              rows={currentCarts}
                              footerContent={footerContent()}
                        />
                  </Card>
            </Stack>
      )
};
